export const TopIssueJankType = Object.freeze({
  RAW: 1,
  PARSED: 2,
  MERGED_ISSUE: 3,
});
